module.exports = __webpack_public_path__ + "img/recluit.b0b6e8f9.webp";